import app from '@/app';
import templateUrl from './materials-services-search.html';

/* @ngInject */
function Controller($controller, $state, DialogService, MaterialsServices, Principal, $http) {
	var $ctrl = this;
	var resource = MaterialsServices;

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;
	$ctrl.transition = function(params) {
		transition(params);
		$ctrl.organization = params.organization;
		$ctrl.name = params.name;
		$ctrl.unit = params.unit;
		resource.query(
			{
				name: $ctrl.name,
				unit: $ctrl.unit,
				sort: $ctrl.sort,
				page: $ctrl.page,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);

		$http.get('api/materialsServices/units', {}).then(function(response) {
			$ctrl.allUnits = response.data;
		});
	};

	$ctrl.remove = (id, name) => resource.remove({ id: id }, () => $state.reload()).$promise;

	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				name: $ctrl.name,
				unit: $ctrl.unit
			},
			{
				reload: true
			}
		);
	};
}

const component = {
	templateUrl,
	controller: Controller,
	bindings: {
		$transition$: '<'
	}
};

app.component('materialsServicesSearch', component);
